import { render, staticRenderFns } from "./TiPillCombo.vue?vue&type=template&id=37a97468&scoped=true&"
import script from "./TiPillCombo.vue?vue&type=script&lang=js&"
export * from "./TiPillCombo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a97468",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib/components/VCombobox';
installComponents(component, {VCombobox})
